
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/main/Home";
import { AuthProvider, useAuth } from "./AuthContext";
import Dashboard from "./pages/main/Dashboard";
import Login from "./pages/auth/Login";
import ProtectedRoute from "./ProtectedRoute";
import ViewVisit from "./pages/main/ViewVisit";
import New from "./pages/main/New";
import Bookings from "./pages/main/Bookings";


function App() {

  function ConditionalRedirect() {
    const { isAuthenticated, currentUser } = useAuth();

    if (isAuthenticated && currentUser) {
      return <Navigate to={`/dashboard/${currentUser.uid}`} replace />;
    }

    return <Login />;
  }


  // Login route that redirects to dashboard if already authenticated
  function LoginWithRedirect() {
    const { isAuthenticated, currentUser } = useAuth();

    if (isAuthenticated && currentUser) {
      return <Navigate to={`/dashboard/${currentUser.uid}`} replace />;
    }

    return <Login />;
  }

  return (
    <>
      <AuthProvider>
        <Routes>
          {/* Home route - redirects to dashboard if authenticated */}
          <Route path="/" element={<ConditionalRedirect />} />

          {/* Login route - redirects to dashboard if authenticated */}
          <Route path="/login" element={<LoginWithRedirect />} />

          {/* Dashboard route with dynamic userId parameter */}
          <Route
            path="/dashboard/:userId"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/new"
            element={
              <ProtectedRoute>
                <New />
              </ProtectedRoute>
            }
          />
          <Route
            path="/visit/:visitId"
            element={
              <ProtectedRoute>
                <ViewVisit />
              </ProtectedRoute>
            }
          />

          <Route
            path="/bookings/:bookingId"
            element={
                <Bookings />
            }
          />

          {/* Catch-all route for any invalid paths */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </>
  );
}

export default App;
